import Button from '../Button/Button';

import MarkdownContent from '../MarkdownContent';

export default function LMS(props) {
	const { blocks, className } = props;

	return (
		<section className={className}>
			<div className="inner">
				<header>
					<MarkdownContent>
						{blocks.modules_rse_title.body}
					</MarkdownContent>
				</header>
				<div className="content">
					<MarkdownContent>
						{blocks.modules_rse_content.body}
					</MarkdownContent>
				</div>
				<div className="action">
					<Button
						href={blocks.modules_rse_content.frontmatter.linkURL}
						className="btn-primary btn-lg"
						sfx="rising-pops"
					>
						{blocks.modules_rse_content.frontmatter.linkTitle}
					</Button>
				</div>
			</div>
		</section>
	);
}
